<template>
	<section class="hamilton-difference-section background-cover" :data-nav-heading="navHeading" :class="{ 'hamilton-difference-section--header': includeNavBar }">

		<transition name="hamilton-difference-section-bg" :duration="2000">
			<div class="hamilton-difference-section-bg background-cover"
				 v-for="(slide, index) in slides" 
				 :key="index"
				 v-if="index == currentSlide"
				 :style=" { 'background-image': 'url(' + encodeURI(slide.backgroundImage) + ')' } "
			>

				<div class="hamilton-difference-section-colorblock" :style=" { 'background-color': slide.colorAccent }"></div>
			</div>
		</transition>

		<div class="hamilton-difference-section-content">
			<h2 class="heading-4 sr-only">The Hamilton Lane Difference</h2>
			<div class="hamilton-difference-section-row row mx-2 m-md-0 h-100">
				<div class="col-12 col-md-5 pt-5 pt-md-0 px-4 px-md-5 d-flex align-items-center mb-4 mb-md-0">
					<transition name="hamilton-difference-section-item" mode="out-in">
						<div 
							v-for="(slide, index) in slides" 
							:key="slide.headline" 
							v-if="index == currentSlide" 
							:class="slide.isBackgroundLight ? 'text-dark' : 'text-white'"
						>
							<h2 v-if="slide.headline.length > 0" v-html="slide.headline"></h2>
							<p v-if="slide.copy.length > 0" v-html="slide.copy"></p>
							<h-button
								v-if="slide.ctaUrl != ''"
								:is-white="!slide.isBackgroundLight"
								:url="slide.ctaUrl"
							>
								{{slide.ctaText}}
							</h-button>
						</div>
					</transition>
				</div>

				<div class="col-12 col-md-7 pl-0 pr-0 pr-md-2 text-center hamilton-difference-section-right h-100 d-flex flex-row flex-lg-column justify-content-center">

					<transition name="hamilton-difference-section-img" mode="out-in">
						<div class="hamilton-difference-section-img" :key="currentSlide" v-if="slides.length > 0" :style="{ 'background-image': 'url(' + encodeURI(slides[currentSlide].featureImage) +  ')'}">
	
						</div>

					</transition>

					<ul class="hamilton-difference-section-dots d-flex flex-row list-unstyled align-items-center" :style="dotContainerStyle">
						<li class="hamilton-difference-section-dot" v-for="(slide, index) in slides" :key="slide.headline" :class="{ active: index == currentSlide }" @click="jumpToSlide(slide, index)">
						</li>

						<li class="hamilton-difference-section-spacer"></li>

						<li class="hamilton-difference-section-pause" :class="{ 'paused': isPaused }">
							<button @click="togglePaused" aria-live="polite" :aria-label="isPaused ? 'Click to play carousel' : 'Click to pause carousel' "><span class="bg-icon hamilton-difference-section-pause-icon"></span></button>
						</li>
					</ul>
				</div>
			</div>
		</div>

		<div class="hamilton-difference-section-progbar m-0">
			<div class="hamilton-difference-section-progbar-fill" :style="progressStyles"></div>
		</div>
	</section>
</template>


<script>
    import HButton from '../components/HButton.vue';
    import BorderedImage from '../components/BorderedImage.vue'
    import TopNav from "../components/TopNav";

    export default {
        components: {
            HButton,
            BorderedImage,
            TopNav,
        },
        data() {
            return {
                autoplayInterval: null,
                currentSlide: 0,
                autoplayProgress: 0.0,
				isPaused: false,
                slides: [ ]
            }
        },
        props: {
            carouselId: {
                type: String,
                default: ''
			},
            cultureCode: {
                type: String,
                default: "en-US"
            },
            autoSlideDelay: {
                type: Number,
                default: 7000.0
            },
            includeNavBar: {
                type: Boolean,
                default: false,
            },
            navHeading: {
                type: String,
                default: ''
            }
        },
        computed: {
            dotContainerStyle() {
                return {

                }

            },
            backgroundStyles() {
                return {
                    'background-image': 'url(' + encodeURI(this.slides[this.currentSlide].backgroundImage) + ')'
                }
            },
            progressStyles() {
                return {
                    width: Math.floor(this.autoplayProgress * 100) + "%"
                }
            }
        },
        mounted() {
            this.$axios.get(this.cultureCode.toLowerCase() + '/slideshow/' + this.carouselId.toLowerCase())
                .then((response) => {
                    this.slides = response.data.slides;
                })
                .catch((error) => {
                    console.log(error);
                });

            this.resetInterval();

            setInterval(() => {
                if (!this.isPaused)
                    this.autoplayProgress += 0.01;
            }, this.autoSlideDelay / 100.0);
        },
        methods: {
            togglePaused() {
                this.isPaused = !this.isPaused;

                if (this.isPaused) {
                    this.autoplayProgress = 0.0;
                    this.stopInterval();
                } else {
                    this.resetInterval();
                }
            },
            resetInterval() {
                if (this.autoplayInterval) {
                    clearInterval(this.autoplayInterval);
                }

                this.autoplayProgress = 0.0;

                // FIXME: only if not hovered?
                this.autoplayInterval = setInterval(() => {
                    this.nextSlide()
                    this.autoplayProgress = 0.0;
                }, this.autoSlideDelay);
            },
            stopInterval() {
                if (this.autoplayInterval) {
                    clearInterval(this.autoplayInterval);
                }

                this.autoplayInterval = null;
            },
            jumpToSlide(slide, index) {
                this.currentSlide = index;

                this.resetInterval();
            },
            nextSlide() {
                if (this.currentSlide < this.slides.length - 1) {
                    this.currentSlide += 1;
                }
                else {
                    this.currentSlide = 0;
                }
            },
            prevSlide() {
                if (this.currentSlide > 0) {
                    this.currentSlide -= 1;
                }
                else {
                    this.currentSlide = this.slides.length - 1;
                }
            }

        }
    }
</script>


<style lang="scss">
	.hamilton-difference-section {

		position: relative;
		.hamilton-difference-section-content {
			position: relative;
			height: 100%;
			// keep images from pushing out the page
			overflow: hidden;
		}
		.hamilton-difference-section-pause button {
			background: transparent;
			border: 0;
			span.hamilton-difference-section-pause-icon {
				background-image: get-icon( 'pause-icon', $white );
				width: 13px;
				height: 14px;
			}

			&:hover {
				opacity: 0.9;
			}



		}

		.hamilton-difference-section-pause.paused button {
			border: 0;
			span.hamilton-difference-section-pause-icon {
				background-image: get-icon( 'play-icon', $white );

			}
		}

		.hamilton-difference-section-bg {
			position: absolute;
			width: 100%;
			height: 100%;
			left: 0;
			right: 0;
			top: 0;
			bottom: 0;
			background-color: black
		}
		@include respond-above(md) {
			height: 80vh;
		}

		&.hamilton-difference-section--header {

			padding-top: 80px;
			margin-top: -80px;

			@include respond-above(md) {
				height: auto !important;
			}
		}

		.hamilton-difference-section-dots {
			position: absolute;
			right: 2rem;
			bottom: 15px;

			z-index: 5;
			justify-content: flex-end;
			left: 0;
			width: 90%;
			@include respond-below(md) {
				bottom: 0px;
				width: calc(100% - 30px);
				left: 15px;

				justify-content: flex-start;
				.hamilton-difference-section-spacer {
					flex-grow: 1.0;
				}
			}
			.hamilton-difference-section-dot {

				cursor: pointer;
				display: block;
				border-radius: 50%;
				width: 10px;
				height: 10px;
				background-color: $lightGrey;
				transition: background-color 0.3s;
				margin-right: 25px;
				&.active {
					background-color: $white;
					transform: scale(1.2, 1.2);
				}

				&:hover {
					opacity: 0.9;
				}

			}		
		}


		.hamilton-difference-section-right {
			position: relative;

		}
		.hamilton-difference-section-colorblock {
			position: absolute;
			height: 35%;
			width: 100%;
			background-color: $orangeText;
			opacity: 0.8;
			bottom:0;
			@include respond-above(md) {
				position: absolute;
				height: 100%;
				width: 30%;
				right: 0;
			}
		}

		.hamilton-difference-section-img {
			width: 90%;
			position: relative;
			margin: 2rem 0 5rem 0;
			background-size: cover;
			background-position: 50% 50%;
			height: 500px;
			@include respond-below(md) {
				height: 325px;
				width: 100%;
				margin: 0 15px;
				margin-bottom: 60px;
			}
		}


	.hamilton-difference-section-bg-enter-active, .hamilton-difference-section-bg-leave-active {
		transition: opacity 1s ease 0.15s;

		@include respond-above(md) {
			.hamilton-difference-section-colorblock {
				transition: all 1.0s ease;
			}
		}
	}

	.hamilton-difference-section-bg-leave-to {
		@include respond-above(md) {
			.hamilton-difference-section-colorblock {		
				transition-duration: 0.5s;
			}
			
		}
	}

	.hamilton-difference-section-bg-enter {
		@include respond-above(md) {
			.hamilton-difference-section-colorblock {		

				transition-delay: 1.0s;
			}
		}

	}
	.hamilton-difference-section-bg-enter, .hamilton-difference-section-bg-leave-to
	{
		opacity: 0;

		@include respond-above(md) {
			.hamilton-difference-section-colorblock {
				width: 0%;
			}
		}

	}





	.hamilton-difference-section-item-enter-active, .hamilton-difference-section-item-leave-active {
		transition: opacity .4s ease, transform 0.70s ease;

	}
	.hamilton-difference-section-item-enter, .hamilton-difference-section-item-leave-to
	{
		opacity: 0;
		transform: translate(0, 100px);

	}

	.hamilton-difference-section-img-enter-active, .hamilton-difference-section-img-leave-active {
		transition: opacity .5s ease, transform 0.50s ease;

	}
	.hamilton-difference-section-img-enter, .hamilton-difference-section-img-leave-to
	{
		opacity: 0;
		transform: translate(100px, 0);

	}

	.hamilton-difference-section-progbar {
		position: absolute;
		width: 100%;
		bottom: 0;
		height: 3px;
		z-index: 5;
		background-color: rgba(255, 255, 255, 0.4);
		//position: relative;
		.hamilton-difference-section-progbar-fill {

			width: 0%;
			background-color: $lightBlue;			
			transition: width 0.2s;
			height: 3px;
		}
	}

	}
</style>
